import { useLocation } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { getConfig } from 'src/global-config';

import { getPageTitle, formatPageTitle, getPageDescription } from '../page-titles';

// ----------------------------------------------------------------------

export type DocumentTitleProps = {
  //Custom title override
  titleOverride?: string;
};

export function DocumentTitle({ titleOverride }: DocumentTitleProps) {
  const { pathname } = useLocation();
  const CONFIG = getConfig();

  const title = titleOverride
    ? formatPageTitle(titleOverride, CONFIG.appName)
    : getPageTitle(pathname, CONFIG.appName);

  const description = getPageDescription(pathname);

  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
    </Helmet>
  );
}
